import { publicOperationMiddleware } from '../permissions/middlewares/publicOperationMiddleware.js';
import { registerMutation, registerSubscription } from '@adornis/baseql/metadata/register.js';
import { authenticatedMiddleware } from '../permissions/middlewares/authenticatedMiddleware.js';
import { EmailChangeTracker } from './change-email-address/EmailChangeTracker.js';
import { sendFreeTextMail } from './free-text-mails/sendFreeTextMails.js';
import { resolveSendEmailVerificationMail } from './server/resolvers/resolveSendEmailVerificationMail.js';
import { resolveSendPasswordResetMail } from './server/resolvers/resolveSendPasswordResetMail.js';
import { resolveStartEmailChangeProcess } from './server/resolvers/resolveStartEmailChangeProcess.js';
import { resolveSubscribeEmailChangeProcess } from './server/resolvers/resolveSubscribeEmailChangeProcess.js';

const startEmailChangeProcess = registerMutation({
  operationName: 'startEmailChangeProcess',
  type: () => Boolean,
  middlewares: [authenticatedMiddleware],
  params: [
    { name: 'userID', type: () => String },
    { name: 'newEmail', type: () => String },
  ],
  resolve: resolveStartEmailChangeProcess,
});

const sendEmailVerificationMail = registerMutation({
  operationName: 'sendEmailVerificationMail',
  type: () => Boolean,
  params: [{ name: 'userID', type: () => String }],
  middlewares: [authenticatedMiddleware],
  resolve: resolveSendEmailVerificationMail,
});

// TODO: do throttleing here
const sendPasswordResetMailOP = registerMutation({
  operationName: 'sendPasswordResetMail',
  middlewares: [publicOperationMiddleware('Passwort vergessen: der Nutzer ist per Definition nicht angemeldet')],
  type: () => Boolean,
  params: [{ name: 'email', type: () => String }],
  resolve: resolveSendPasswordResetMail,
});

const subscribeEmailChangeProcess = registerSubscription({
  operationName: 'subscribeEmailChangeProcess',
  type: () => EmailChangeTracker,
  params: [{ name: 'userID', type: () => String }],
  middlewares: [authenticatedMiddleware],
  resolve: resolveSubscribeEmailChangeProcess,
});

export const UserEmailsAPI = {
  startEmailChange: startEmailChangeProcess,
  subscribeEmailChange: subscribeEmailChangeProcess,
  sendVerificationEmail: sendEmailVerificationMail,
  sendPasswordResetMail: sendPasswordResetMailOP,
  sendFreeTextMail,
};
